module.exports = __webpack_public_path__ + "static/media/DolatodeStatoFont.fc0606c8.ttf";